import Vue from 'vue'
import App from './App.vue'
import 'bootstrap/dist/css/bootstrap.min.css'
import store from './store'
import router from './router'
import VModal from 'vue-js-modal'
import numeral from 'numeral';
import numFormat from 'vue-filter-number-format';
import Toast from "vue-toastification";
// Import the CSS or use your own!
import "vue-toastification/dist/index.css";

const options = {
    // You can set your default options here
};


Vue.use(Toast, options);
//import 'vue-instant/dist/vue-instant.css'
//import VueInstant from 'vue-instant/dist/vue-instant.common'

Vue.use(VModal,  { dynamicDefault: { draggable: true, resizable: true } })
Vue.filter('numFormat', numFormat(numeral));

new Vue({
    router,
    store,
    //components: {VueQr},
    //VuexI18n,
    render: h => h(App)
  }).$mount('#app')

